import React from 'react';
import { inject, observer } from 'mobx-react';
import {WeaLocaleProvider} from "ecCom";
const getLabel = WeaLocaleProvider.getLabel;

@inject('portalLoginStore')
@observer
class LoginBtn extends React.Component {
    constructor(props) {
        super(props);
        this.onLogin = this.onLogin.bind(this);
    }


    render() {
        const { portalLoginStore, getState } = this.props;
        let { state } = portalLoginStore;
        state = getState();
        const { loginSettingInfo } = state;
        let { loginForm } = loginSettingInfo;
        const { e7LoginButtonColor } = loginForm;

        return (
            <div className="loginBtns"  >
                <div className="loginBtn" onClick={this.onLogin}>{getLabel(674, '登录')}</div>
                <div className="resetBtn" onClick={this.onReset}>{getLabel(2022, '重置')}</div>
            </div>
        );
    }
    onLogin() {
        const { portalLoginStore, isSetting } = this.props;
        if (!isSetting) {
            portalLoginStore.onLogin();
        }
    }

    onReset = ()=>{
        $(".simplelogin-form input").val("")
    }
}

export default LoginBtn;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/login/simpleLogin/formCloud/LoginBtn.js